export default [
  'Audiciones',
  'Estrenos',
  'Encuentros',
  'Búsquedas de casting',
  'Formación',
  'Concursos',
  'Festivales',
];



// WEBPACK FOOTER //
// ./src/utils/Interests.js